import React from "react";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "./custom-components.style.scss";
import { iosClose } from '../../assets/images/index.js';
import PropTypes from "prop-types";

const TypeaheadInput = (props) => {
  const {
  containerClassName="frmgroup validate default-input col-6",
  customlabelClassName="",
  error=false,
  errorClassName="",
  errorMessage="",
  handleInputChange,
  id="",
  label="",
  labelClassName="",
  multi=false,
} = props;

  return (
    <>
      {props?.inputOnly ? (
        <div
          className={
            containerClassName
              ? containerClassName
              : "frmgroup validate default-input col-6"
          }
          id={id}
        >
          <div className={`frmhead ${labelClassName}`}>
            {label && <label className={customlabelClassName}>{label} </label>}
            {error && (
              <div className={`error ${errorClassName}`}>{errorMessage}</div>
            )}
          </div>
          <AsyncTypeahead
            {...props}
            className={`app-config-filter ${props?.customClassName}`}
            labelKey="label"
            minLength={0}
            disabled={props?.isDisabled}
            onInputChange={handleInputChange}
            renderMenuItemChildren={(option, props, idx) => (
              <div>{option[props.labelKey]}</div>
            )}
          />
        </div>
      ) : (
        <div
          className={
            containerClassName
              ? containerClassName
              : "frmgroup validate default-input col-6"
          }
          id={id}
        >
          <div className={`frmhead ${labelClassName}`}>
            {label && <label>{label} </label>}
            {error && (
              <div className={`error ${errorClassName}`}>{errorMessage}</div>
            )}
          </div>

          <AsyncTypeahead
            inputProps={{
              style: {
                border: error && "1px solid red",
              },
            }}
            minLength={1}
            {...props}
            className={`app-config-filter ${props?.customClassName}`}
            labelKey="label"
            multiple={multi}
            onInputChange={handleInputChange}
            renderMenuItemChildren={(option, props) => (
              <div className="dropdown-item">{option[props.labelKey]}</div>
            )}
            renderToken={(option, props, idx) => (
              <div className="token " key={idx} style={{ display: 'flex', alignItems: 'center', border: '1px solid #ccc', borderRadius: '8px', padding: '2px', marginRight: '3px',margin: "1px" , backgroundColor: '#fff' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {option[props.labelKey]}
                </div>
                {props.onRemove && (
                  <button type="button"
                    onClick={() => props.onRemove(option)}
                    style={{ border: 'none', padding: 0, background: 'none', marginLeft: '3px' }}
                  >
                    <img src={iosClose} alt="removeUser" />
                  </button>
                )}
              </div>
            )}
            
      />
        </div>
      )}
    </>
  );
};

export default React.memo(TypeaheadInput);

TypeaheadInput.propTypes = {
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  errorClassName: PropTypes.string,
  multi: PropTypes.bool,
  label: PropTypes.string,
  containerClassName: PropTypes.string,
  id: PropTypes.string,
  labelClassName: PropTypes.string,
  customlabelClassName: PropTypes.string,
  handleInputChange: PropTypes.func,
  inputOnly: PropTypes.bool,
  customClassName: PropTypes.string,
  isDisabled: PropTypes.bool,
  onRemove: PropTypes.func,
  labelKey: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),
};



